// Lista de países con sus códigos de teléfono y banderas
export const countries = [
  { code: 'AR', name: 'Argentina', dialCode: '+54', flag: '🇦🇷' },
  { code: 'BO', name: 'Bolivia', dialCode: '+591', flag: '🇧🇴' },
  { code: 'BR', name: 'Brasil', dialCode: '+55', flag: '🇧🇷' },
  { code: 'CL', name: 'Chile', dialCode: '+56', flag: '🇨🇱' },
  { code: 'CO', name: 'Colombia', dialCode: '+57', flag: '🇨🇴' },
  { code: 'CR', name: 'Costa Rica', dialCode: '+506', flag: '🇨🇷' },
  { code: 'CU', name: 'Cuba', dialCode: '+53', flag: '🇨🇺' },
  { code: 'DO', name: 'República Dominicana', dialCode: '+1-809', flag: '🇩🇴' },
  { code: 'EC', name: 'Ecuador', dialCode: '+593', flag: '🇪🇨' },
  { code: 'SV', name: 'El Salvador', dialCode: '+503', flag: '🇸🇻' },
  { code: 'GT', name: 'Guatemala', dialCode: '+502', flag: '🇬🇹' },
  { code: 'HN', name: 'Honduras', dialCode: '+504', flag: '🇭🇳' },
  { code: 'MX', name: 'México', dialCode: '+52', flag: '🇲🇽' },
  { code: 'NI', name: 'Nicaragua', dialCode: '+505', flag: '🇳🇮' },
  { code: 'PA', name: 'Panamá', dialCode: '+507', flag: '🇵🇦' },
  { code: 'PY', name: 'Paraguay', dialCode: '+595', flag: '🇵🇾' },
  { code: 'PE', name: 'Perú', dialCode: '+51', flag: '🇵🇪' },
  { code: 'PR', name: 'Puerto Rico', dialCode: '+1-787', flag: '🇵🇷' },
  { code: 'UY', name: 'Uruguay', dialCode: '+598', flag: '🇺🇾' },
  { code: 'VE', name: 'Venezuela', dialCode: '+58', flag: '🇻🇪' },
  { code: 'ES', name: 'España', dialCode: '+34', flag: '🇪🇸' },
  { code: 'US', name: 'Estados Unidos', dialCode: '+1', flag: '🇺🇸' },
  { code: 'CA', name: 'Canadá', dialCode: '+1', flag: '🇨🇦' },
  { code: 'GB', name: 'Reino Unido', dialCode: '+44', flag: '🇬🇧' },
  { code: 'FR', name: 'Francia', dialCode: '+33', flag: '🇫🇷' },
  { code: 'DE', name: 'Alemania', dialCode: '+49', flag: '🇩🇪' },
  { code: 'IT', name: 'Italia', dialCode: '+39', flag: '🇮🇹' },
  { code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
  { code: 'CN', name: 'China', dialCode: '+86', flag: '🇨🇳' },
  { code: 'JP', name: 'Japón', dialCode: '+81', flag: '🇯🇵' },
  { code: 'KR', name: 'Corea del Sur', dialCode: '+82', flag: '🇰🇷' },
  { code: 'IN', name: 'India', dialCode: '+91', flag: '🇮🇳' },
  { code: 'AU', name: 'Australia', dialCode: '+61', flag: '🇦🇺' },
  { code: 'NZ', name: 'Nueva Zelanda', dialCode: '+64', flag: '🇳🇿' },
  { code: 'ZA', name: 'Sudáfrica', dialCode: '+27', flag: '🇿🇦' },
  { code: 'EG', name: 'Egipto', dialCode: '+20', flag: '🇪🇬' },
  { code: 'NG', name: 'Nigeria', dialCode: '+234', flag: '🇳🇬' },
  { code: 'IL', name: 'Israel', dialCode: '+972', flag: '🇮🇱' },
  { code: 'AE', name: 'Emiratos Árabes Unidos', dialCode: '+971', flag: '🇦🇪' },
  { code: 'SA', name: 'Arabia Saudita', dialCode: '+966', flag: '🇸🇦' },
  { code: 'RU', name: 'Rusia', dialCode: '+7', flag: '🇷🇺' },
  { code: 'PL', name: 'Polonia', dialCode: '+48', flag: '🇵🇱' },
  { code: 'NL', name: 'Países Bajos', dialCode: '+31', flag: '🇳🇱' },
  { code: 'BE', name: 'Bélgica', dialCode: '+32', flag: '🇧🇪' },
  { code: 'SE', name: 'Suecia', dialCode: '+46', flag: '🇸🇪' },
  { code: 'NO', name: 'Noruega', dialCode: '+47', flag: '🇳🇴' },
  { code: 'DK', name: 'Dinamarca', dialCode: '+45', flag: '🇩🇰' },
  { code: 'FI', name: 'Finlandia', dialCode: '+358', flag: '🇫🇮' },
  { code: 'CH', name: 'Suiza', dialCode: '+41', flag: '🇨🇭' },
  { code: 'AT', name: 'Austria', dialCode: '+43', flag: '🇦🇹' },
  { code: 'GR', name: 'Grecia', dialCode: '+30', flag: '🇬🇷' },
  { code: 'TR', name: 'Turquía', dialCode: '+90', flag: '🇹🇷' },
  { code: 'PH', name: 'Filipinas', dialCode: '+63', flag: '🇵🇭' },
  { code: 'TH', name: 'Tailandia', dialCode: '+66', flag: '🇹🇭' },
  { code: 'MY', name: 'Malasia', dialCode: '+60', flag: '🇲🇾' },
  { code: 'SG', name: 'Singapur', dialCode: '+65', flag: '🇸🇬' },
  { code: 'ID', name: 'Indonesia', dialCode: '+62', flag: '🇮🇩' },
  { code: 'VN', name: 'Vietnam', dialCode: '+84', flag: '🇻🇳' }
];

// Función para detectar el país por IP usando una API gratuita
export async function detectCountryByIP() {
  try {
    // Intentar con ipapi.co primero (no requiere API key)
    const response = await fetch('https://ipapi.co/json/');
    if (response.ok) {
      const data = await response.json();
      const country = countries.find(c => c.code === data.country_code);
      if (country) {
        return country;
      }
    }
  } catch (error) {
    console.log('Error detectando país por IP:', error);
  }
  
  // Si falla la detección, intentar con el timezone del navegador
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    // Mapeo básico de timezones a países
    const timezoneCountryMap = {
      'America/Argentina': 'AR',
      'America/Buenos_Aires': 'AR',
      'America/Mexico_City': 'MX',
      'America/Bogota': 'CO',
      'America/Lima': 'PE',
      'America/Santiago': 'CL',
      'America/Sao_Paulo': 'BR',
      'America/Montevideo': 'UY',
      'America/Caracas': 'VE',
      'America/La_Paz': 'BO',
      'America/Asuncion': 'PY',
      'America/Guayaquil': 'EC',
      'America/Costa_Rica': 'CR',
      'America/Panama': 'PA',
      'America/Guatemala': 'GT',
      'America/El_Salvador': 'SV',
      'America/Tegucigalpa': 'HN',
      'America/Managua': 'NI',
      'America/Havana': 'CU',
      'America/Santo_Domingo': 'DO',
      'America/Puerto_Rico': 'PR',
      'Europe/Madrid': 'ES',
      'America/New_York': 'US',
      'America/Los_Angeles': 'US',
      'America/Chicago': 'US',
      'America/Toronto': 'CA',
      'Europe/London': 'GB',
      'Europe/Paris': 'FR',
      'Europe/Berlin': 'DE',
      'Europe/Rome': 'IT',
      'Europe/Lisbon': 'PT'
    };
    
    for (const [tz, code] of Object.entries(timezoneCountryMap)) {
      if (timezone.includes(tz)) {
        const country = countries.find(c => c.code === code);
        if (country) {
          return country;
        }
      }
    }
  } catch (error) {
    console.log('Error detectando país por timezone:', error);
  }
  
  // Default: Argentina
  return countries.find(c => c.code === 'AR');
}

// Función para formatear el número completo con prefijo
export function formatPhoneWithCountry(phone, country) {
  // Eliminar espacios y caracteres especiales
  const cleanPhone = phone.replace(/\D/g, '');
  
  // Si ya tiene el código del país, devolverlo como está
  const dialCodeClean = country.dialCode.replace(/\D/g, '');
  if (cleanPhone.startsWith(dialCodeClean)) {
    return '+' + cleanPhone;
  }
  
  // Si no tiene el código, agregarlo
  return country.dialCode + cleanPhone;
}

// Función para validar un número de teléfono
export function validatePhoneNumber(phone, country) {
  const cleanPhone = phone.replace(/\D/g, '');
  
  // Validación básica de longitud (entre 7 y 15 dígitos sin el código de país)
  if (cleanPhone.length < 7 || cleanPhone.length > 15) {
    return false;
  }
  
  // Validaciones específicas por país
  switch (country.code) {
    case 'AR':
      // Argentina: diferentes formatos válidos
      // Móviles: 11 XXXX-XXXX (Buenos Aires), 9 XXXX-XXXX (otras provincias)
      // Fijos: XXXX-XXXX con código de área
      // Longitud típica: 8-11 dígitos (sin código de país)
      return cleanPhone.length >= 8 && cleanPhone.length <= 11;
    case 'MX':
      // México: 10 dígitos
      return cleanPhone.length === 10;
    case 'BR':
      // Brasil: 10 o 11 dígitos
      return cleanPhone.length === 10 || cleanPhone.length === 11;
    case 'US':
    case 'CA':
      // USA/Canada: 10 dígitos
      return cleanPhone.length === 10;
    case 'ES':
      // España: 9 dígitos
      return cleanPhone.length === 9;
    default:
      // Validación genérica
      return true;
  }
}